import { createContext, useCallback, useContext, useMemo, useState } from "react";

const AdminNotificationsContext = createContext(null);

export function AdminNotificationsProvider({ children }) {
  const [items, setItems] = useState([]);
  const notify = useCallback((message, type = "success") => {
    const id = `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    setItems((current) => [...current, { id, message, type }]);
    window.setTimeout(() => setItems((current) => current.filter((item) => item.id !== id)), 3600);
  }, []);
  const value = useMemo(() => ({ notify }), [notify]);
  return <AdminNotificationsContext.Provider value={value}>
    {children}
    <div aria-live="polite" style={{ position: "fixed", right: "var(--admin-modal-gutter)", bottom: "var(--admin-modal-gutter)", zIndex: 9000, display: "flex", flexDirection: "column", gap: "var(--admin-gap-sm)", width: "min(320px,calc(100vw - 2 * var(--admin-modal-gutter)))", pointerEvents: "none" }}>
      {items.map((item) => <div key={item.id} style={{ padding: "var(--admin-control-padding-y) var(--admin-control-padding-x)", borderRadius: "var(--admin-radius)", border: `1px solid ${item.type === "error" ? "var(--danger)" : item.type === "partial" ? "var(--accent-border)" : "var(--success)"}`, background: item.type === "error" ? "var(--danger-soft)" : item.type === "partial" ? "var(--accent-soft)" : "var(--success-soft)", color: "var(--text-main)", boxShadow: "var(--shadow-panel)", fontSize: "var(--admin-text-sm)", fontWeight: 700 }}>{item.message}</div>)}
    </div>
  </AdminNotificationsContext.Provider>;
}

export function useAdminNotifications() {
  const value = useContext(AdminNotificationsContext);
  if (!value) throw new Error("useAdminNotifications must be used inside AdminNotificationsProvider");
  return value;
}
